import React from 'react';
import { Truck, Palette, Building2, Sparkles, Shield } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  truck: Truck,
  palette: Palette,
  building: Building2,
  sparkles: Sparkles,
  shield: Shield,
};

const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.icon] || Truck;

  return (
    <div className="group bg-slate-800/50 rounded-xl overflow-hidden hover:bg-slate-800/70 transition-all duration-300 hover:transform hover:scale-[1.02] hover:shadow-xl">
      {/* Image */}
      <div className="relative h-48 overflow-hidden">
        <img
          src={service.image}
          alt={`${service.title} — professional installation in Sacramento, CA by WrapAlot Specialty Filmz`}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Icon */}
        <div className="w-12 h-12 bg-cyan-500/20 rounded-lg flex items-center justify-center mb-4">
          <IconComponent className="w-6 h-6 text-cyan-400" />
        </div>

        <h3 className="text-xl font-bold text-white mb-3">
          {service.title}
        </h3>
        
        <p className="text-gray-400 leading-relaxed text-sm">
          {service.description}
        </p>
      </div>
    </div>
  );
};

const Services = () => {
  return (
    <section id="services" className="bg-slate-900 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Services
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Professional vehicle wrapping solutions for every need
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
